import { constructEnum } from '@/lib/enum';

export default constructEnum('WidgetDeviceType', {
  PC: 10,
  MOBILE: 30,
  PC_MOBILE: 20
});
